<template>
  <div>
    <!-- Table dialog servicios -->
    <el-dialog
      :title="title"
      :visible = "isVisible"
      :close-on-click-modal = "false"
      :before-close="handleClose"
      :fullscreen="true"
      center>

      <el-row :gutter="20">
        <el-form :model="data">

          <el-col :span="4">
            <el-radio-group v-if="rulesCanBeAdded" v-model="distribution_type_selected">
              <el-radio label="weight" size="mini" border>Tipo Peso</el-radio>
              <el-radio label="zone" size="mini" border>Tipo Zona</el-radio>
            </el-radio-group>
          </el-col>

          <el-col :span="16">
            <el-button
              v-if="rulesCanBeAdded"
              size="mini"
              icon="el-icon-s-operation"
              type="success"
              plain
              @click="handleAdd">Agregar Configuracion
            </el-button>
          </el-col>

          <el-col :span="4">
            <div style="float: right; padding: 3px 0" >
              Mostrar JSON
            <el-switch v-model="showJson" @change="switchCols"></el-switch>
            </div>
          </el-col>
        </el-form>
      </el-row>

      <hr>

      <el-row :gutter="20">
        <el-col :span="24">
          <div v-for="(service, index) in rules" :key="index">

            <!-- Weight service.type -->
            <div v-if="service.isWeight()">
              <el-container style="margin-bottom: 30px;">
                <el-aside width="280px">
                  <h3>Configuración</h3>
                  <el-form label-position="top" class="demo-form-inline">
                    <el-form-item label="Tipo de servicio">
                      <el-select v-model="service.code" placeholder="Seleccionar">
                        <el-option v-for="type in options_services"
                          :key="type.value"
                          :label="type.label"
                          :value="type.value">
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <h3>Filtros</h3>
                    <FilterCustom
                      title="Filtrar por pais de origen:"
                      subtitle="Lista de Países"
                      :initialState="enableShipperCountry[index]"
                      :itemList="options_allowed_countries"
                      :initialSelectedItems="getArrayOfObject(
                        service, 'allowed_countries', 'shipper', 'countries'
                      )"
                      :initialFilterType="getValueOfObject(
                        service, 'allowed_countries', 'shipper', 'filter_type'
                      )"
                      @changeState="changeFilter(
                        service,
                        'allowed_countries',
                        'shipper',
                        'countries',
                        index,
                        enableShipperCountry,
                        backup,
                      )"
                      @changeSelect="(value) => service.allowed_countries.shipper.countries = value"
                      @changeType="(value) => service.allowed_countries.shipper.filter_type = value"
                    />
                    <FilterCustom
                      title="Filtrar por país de destino:"
                      subtitle="Lista de Países"
                      :initialState="enable_recipient[index]"
                      :itemList="options_allowed_countries"
                      :initialSelectedItems="getArrayOfObject(
                        service, 'allowed_countries', 'recipient', 'countries'
                      )"
                      :initialFilterType="getValueOfObject(
                        service, 'allowed_countries', 'recipient', 'filter_type'
                      )"
                      @changeState="changeFilter(
                        service,
                        'allowed_countries',
                        'recipient',
                        'countries',
                        index,
                        enable_recipient,
                        backup,
                      )"
                      @changeSelect="(value) =>
                        service.allowed_countries.recipient.countries = value"
                      @changeType="(value) =>
                        service.allowed_countries.recipient.filter_type = value"
                    />
                    <!-- /////////////////////////////////////////////////////////////////////// -->
                    <br>

                  </el-form>
                </el-aside>
                <el-container>
                  <el-main>
                    <el-row :gutter="20">
                      <span>
                        Tipo de distribución:
                          <el-tag effect="plain">{{service.type.toUpperCase()}}</el-tag>
                      </span>

                        <el-tag
                          v-if="!getMax(service.code)"
                          type="warning"
                          style="margin-left: 20px;"
                        > Servicio NO Encontrado </el-tag>
                        <el-button
                        @click="removeItem(index, rules)"
                        icon="el-icon-delete-solid"
                        size="mini"
                        style="float: right;"
                        round
                        plain
                        type="danger">Borrar
                      </el-button>
                      <hr>
                    </el-row>

                      <el-col :span="sliderCol">
                        <el-row
                          :gutter="20"
                          v-for="(configuration, index_range) in service.configuration"
                          :key="index_range"
                        >
                        <el-col :span="2">
                          <el-button
                            type="danger"
                            icon="el-icon-close"
                            class="pt-10"
                            size="mini"
                            plain
                            circle
                            @click="removeItem(index_range, configuration)">
                          </el-button>
                        </el-col>
                        <el-col :span="16">
                          <div class="range">
                            {{rules[index].configuration[index_range].range}}
                          </div>
                          <el-slider
                            range
                            v-model="rules[index].configuration[index_range].range"
                            :min="1"
                            :max="getMax(service.code)"
                            :marks="getMaxMarks(service.code)"></el-slider>
                        </el-col>

                      </el-row>
                    </el-col>

                    <el-col :span="jsonCol">
                      <pre v-if="showJson" v-html="$options.filters.prettyAreaData(service)"></pre>
                    </el-col>

                    <el-button
                      @click="service.addRange()"
                      icon="el-icon-circle-plus"
                      type="text">Agregar rango
                    </el-button>

                  </el-main>
                </el-container>
              </el-container>
            </div>

            <!-- Zone service.type -->
            <div v-if="service.isZone()">
              <el-container style="margin-bottom: 30px;">
                <el-aside width="280px">
                  <h3>Configuración</h3>
                  <el-form label-position="top" class="demo-form-inline">
                    <el-form-item label="Tipo de servicio">
                      <el-select v-model="service.code"  placeholder="Seleccionar">
                      <el-option v-for="type in options_services"
                        :key="type.value"
                        :label="type.label"
                        :value="type.value">
                      </el-option>
                    </el-select>
                    </el-form-item>

                    <h3>Filtros</h3>
                    <FilterCustom
                      title="Filtrar por pais de origen:"
                      subtitle="Lista de Países"
                      :initialState="enableShipperCountry[index]"
                      :itemList="options_allowed_countries"
                      :initialSelectedItems="getArrayOfObject(
                        service, 'allowed_countries', 'shipper', 'countries'
                      )"
                      :initialFilterType="getValueOfObject(
                        service, 'allowed_countries', 'shipper', 'filter_type'
                      )"
                      @changeState="changeFilter(
                        service,
                        'allowed_countries',
                        'shipper',
                        'countries',
                        index,
                        enableShipperCountry,
                        backup,
                      )"
                      @changeSelect="(value) => service.allowed_countries.shipper.countries = value"
                      @changeType="(value) => service.allowed_countries.shipper.filter_type = value"
                    />
                    <FilterCustom
                      title="Filtrar por país de destino:"
                      subtitle="Lista de Países"
                      :initialState="enable_recipient[index]"
                      :itemList="options_allowed_countries"
                      :initialSelectedItems="getArrayOfObject(
                        service, 'allowed_countries', 'recipient', 'countries'
                      )"
                      :initialFilterType="getValueOfObject(
                        service, 'allowed_countries', 'recipient', 'filter_type'
                      )"
                      @changeState="changeFilter(
                        service,
                        'allowed_countries',
                        'recipient',
                        'countries',
                        index,
                        enable_recipient,
                        backup,
                      )"
                      @changeSelect="(value) =>
                        service.allowed_countries.recipient.countries = value"
                      @changeType="(value) =>
                        service.allowed_countries.recipient.filter_type = value"
                    />
                    <!-- /////////////////////////////////////////////////////////////////// -->
                    <br>

                  </el-form>
                </el-aside>

                <el-container>
                  <el-main>
                    <el-row :gutter="20">
                      <span>
                        Tipo de distribución: <el-tag
                        effect="plain" type="success"> {{service.type.toUpperCase()}}</el-tag>
                      </span>
                      <el-tag
                        v-if="!getMax(service.code)"
                        type="warning" style="margin-left: 20px;"> Servicio NO Encontrado </el-tag>

                      <el-button
                        style="float: right; margin-left: 10px;"
                        type="success"
                        icon="el-icon-delete-solid"
                        size="mini"
                        round
                        plain
                        @click="service.addZone()"
                      >Agregar otra zona
                      </el-button>
                      <el-button
                        style="float: right;"
                        type="danger"
                        icon="el-icon-delete-solid"
                        size="mini"
                        round
                        plain
                        @click="removeItem(index, rules)">Borrar
                      </el-button>

                    </el-row>
                    <div
                      v-for="(configuration, index_configuration) in service.configuration"
                      :key="index_configuration">
                      <hr>
                      <el-row :gutter="20">
                        <el-button
                          @click="removeItem(index_configuration, service.configuration)"
                          icon="el-icon-delete-solid"
                          size="mini"
                          style="float: left;"
                          type="danger"
                          circle>
                        </el-button>
                      </el-row>

                      <el-row :gutter="20" style="text-align: right;">
                        <el-col :span="sliderCol">
                          <el-select v-model="configuration.zone" placeholder="Zona">
                            <el-option v-for="type in options_zones"
                              :key="type.value"
                              :label="type.label"
                              :value="type.value">
                            </el-option>
                          </el-select>
                        </el-col>
                        <br>
                      </el-row>

                      <el-col :span="sliderCol">
                        <el-row
                          :gutter="20"
                          v-for="(configuration, index_range) in configuration.ranges"
                          :key="index_range">
                          <el-col :span="2">
                            <el-button
                              type="danger"
                              icon="el-icon-close"
                              class="pt-10"
                              size="mini"
                              plain
                              @click="removeItem(index_range,
                              rules[index].configuration[index_configuration].ranges)"
                              circle>
                            </el-button>
                          </el-col>
                          <el-col :span="16">
                            <div
                              class="range"
                            >
                              {{
                                rules[index].
                                configuration[index_configuration].ranges[index_range].range
                              }}
                            </div>
                            <el-slider
                              :min="1"
                              :max="getMax(service.code)"
                              :marks="getMaxMarks(service.code)"
                              v-model="rules[index]
                                .configuration[index_configuration].ranges[index_range].range"
                              range></el-slider>
                          </el-col>

                        </el-row>
                      </el-col>

                      <el-col :span="jsonCol">
                        <pre
                          v-if="showJson"
                          v-html="$options.filters.prettyAreaData(service)"></pre>
                      </el-col>

                      <el-button
                        @click="configuration.addRange()"
                        icon="el-icon-circle-plus"
                        type="text">Agregar rango
                      </el-button>
                      <br>
                    </div>
                  </el-main>
                </el-container>
              </el-container>
            </div>

          </div>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button
          type="success"
          icon="el-icon-check"
          @click="handleSave"
          round
        >Guardar cambios
        </el-button>
      </span>

    </el-dialog>
    <!-- END Table dialog servicios -->
  </div>
</template>

<script>
import http from '@/utils/http';
import country_codes from '@/utils/constants/countryCodes';
import state_codes from '@/utils/constants/stateCodes';
import FilterCustom from '@/components/FilterCustom.vue';
import { RulesResponse } from './RulesResponse/RulesResponse';
import { Rules } from './RulesResponse/Rules';

export default {
  name: 'RuleSettingsModal',
  props: ['id', 'isVisible', 'ruleType'],
  components: { FilterCustom },
  data() {
    return {
      rules: [],
      dataResponse: {},
      date: '',

      backup: [],
      backup_states: [],

      enable_recipient: [],
      enableShipperCountry: [],
      enable_recipient_states: [],
      enable_shipper_states: [],

      options_allowed_countries: country_codes,
      options_allowed_states: state_codes,

      showJson: false,
      sliderCol: 24,
      jsonCol: 0,

      distribution_type_selected: 'weight',
      title: '',
      max_weight: {},
      data: {
        rules: [],
      },
      options_zones: this.createSelectZones(),
      options_services: [
      ],
      options: [{
        value: 'production',
        label: 'Produccion',
      },
      {
        value: 'development',
        label: 'Desarrollo',
      }],
    };
  },
  computed: {
    rulesCanBeAdded() {
      return this.rules.length < 1;
    },
  },
  watch: {
    async isVisible() {
      if (this.id && this.isVisible) {
        const response = await http.get(`/rules/${this.id}`);
        const rulesResponse = new RulesResponse(response);
        this.rules = rulesResponse.data.rules ? [rulesResponse.data.rules] : [];
        response.data.rules = response.data?.rules ? [response.data.rules] : [];
        this.data = response.data;

        this.title = `Regla de ${rulesResponse.data.carrier}/${rulesResponse.data.name}`;

        // localhost:3010/v1/=ups
        const { data } = await http
          .get(`/carriers/services/?carrier=${rulesResponse.data.carrier}`);

        // name: "standard", code: "STANDARD", max_weight: 5
        this.options_services = data[0].services.map((element) => ({
          value: element.code,
          label: element.name,
        }));

        data[0].services.forEach((element) => {
          this.max_weight[element.code] = element.max_weight;
        });

        this.enable_recipient = this.rules.map((service) => {
          if (!service.allowed_countries) return false;
          return !!service.allowed_countries.recipient;
        });

        this.enableShipperCountry = this.rules.map((service) => {
          if (!service.allowed_countries) return false;
          return !!service.allowed_countries.shipper;
        });

        this.enable_recipient_states = this.rules.map((service) => {
          if (!service.allowed_states) return false;
          return !!service.allowed_states.recipient;
        });

        this.enable_shipper_states = this.rules.map((service) => {
          if (!service.allowed_states) return false;
          return !!service.allowed_states.shipper;
        });

        this.backup = this.rules
          .map(() => ({
            recipient: {
              filter_type: 'include',
              countries: [],
            },
            shipper: {
              filter_type: 'include',
              states: [],
            },
          }));

        this.backup_states = this.rules
          .map(() => ({
            recipient: {
              filter_type: 'include',
              states: [],
            },
            shipper: {
              filter_type: 'include',
              states: [],
            },
          }));
      } else {
        this.title = 'Nuevo Proveedor';
      }
    },
  },

  methods: {
    getArrayOfObject(service, allowedKey, source, area) {
      return service[allowedKey] && service[allowedKey][source]
        ? service[allowedKey][source][area]
        : [];
    },

    getValueOfObject(service, allowedKey, source, area) {
      return service[allowedKey] && service[allowedKey][source]
        ? service[allowedKey][source][area]
        : 'include';
    },

    changeFilter(service, serviceKey, source, key, index, list, backup) {
      // eslint-disable-next-line no-param-reassign
      list[index] = !list[index];
      if (!service[serviceKey]) {
        this.$set(service, serviceKey, {});
      }
      const sourceValue = service[serviceKey][source];
      if (sourceValue) {
        // eslint-disable-next-line no-param-reassign
        backup[index][source] = sourceValue;
      }

      if (!backup[index][source]) {
        this.$set(backup, source, {
          filter_type: 'include',
          [key]: [],
        });
      }

      if (list[index]) {
        this.$set(service[serviceKey], source, backup[index][source]);
      } else {
        this.$delete(service[serviceKey], source);
      }
    },

    switchCols() {
      this.sliderCol = this.showJson ? 18 : 24;
      this.jsonCol = this.showJson ? 6 : 0;
    },

    changeShipperCountry(service, index) {
      if (service.allowed_countries.shipper) {
        this.backup[index].shipper = service.allowed_countries.shipper;
      }

      if (!this.backup[index].shipper) {
        this.$set(this.backup, 'shipper', {
          filter_type: 'include',
          countries: [],
        });
      }

      if (this.enableShipperCountry[index]) {
        // eslint-disable-next-line no-param-reassign
        service.allowed_countries.shipper = this.backup[index].shipper;
      } else {
        this.$delete(service.allowed_countries, 'shipper');
      }
    },

    change_recipient(service, index) {
      if (this.enable_recipient_states[index]) {
        // this.enable_recipient_states[index] = false;
        // this.change_recipient_state(service, index);
      }

      if (!service.allowed_countries) {
        // eslint-disable-next-line no-param-reassign
        service.allowed_countries = {};
      }

      if (service.allowed_countries.recipient) {
        this.backup[index].recipient = service.allowed_countries.recipient;
      }

      if (!this.backup[index].recipient) {
        this.$set(this.backup, 'recipient', {
          filter_type: 'include',
          countries: [],
        });
      }

      if (this.enable_recipient[index]) {
        // eslint-disable-next-line no-param-reassign
        service.allowed_countries.recipient = this.backup[index].recipient;
      } else {
        // delete allowed_countries.recipient;
        this.$delete(service.allowed_countries, 'recipient');
      }
    },

    change_recipient_state(service, index) {
      if (this.enable_recipient[index]) {
        // this.enable_recipient[index] = false;
        // this.change_recipient(service, index);
      }

      try {
        if (!service.allowed_states) {
          // eslint-disable-next-line no-param-reassign
          service.allowed_states = {};
        }

        if (service.allowed_states.recipient) {
          this.backup_states[index].recipient = service.allowed_states.recipient;
        }

        if (!this.backup_states[index].recipient) {
          this.$set(this.backup_states, 'recipient', {
            filter_type: 'include',
            states: [],
          });
        }

        if (this.enable_recipient_states[index]) {
          // eslint-disable-next-line no-param-reassign
          service.allowed_states.recipient = this.backup_states[index].recipient;
        } else {
          // delete allowed_state.recipient;
          this.$delete(service.allowed_states, 'recipient');
        }
      } catch (error) {
        console.log(error);
      }
    },
    change_shipper_state(service, index) {
      if (this.enable_recipient[index]) {
        // this.enable_recipient[index] = false;
        // this.change_recipient(service, index);
      }

      try {
        if (!service.allowed_states) {
          // eslint-disable-next-line no-param-reassign
          service.allowed_states = {};
        }

        if (service.allowed_states.shipper) {
          this.backup_states[index].shipper = service.allowed_states.shipper;
        }

        if (!this.backup_states[index].shipper) {
          this.$set(this.backup_states, 'shipper', {
            filter_type: 'include',
            states: [],
          });
        }

        if (this.enable_shipper_states[index]) {
          // eslint-disable-next-line no-param-reassign
          service.allowed_states.shipper = this.backup_states[index].shipper;
        } else {
          // delete allowed_state.shipper;
          this.$delete(service.allowed_states, 'shipper');
        }
      } catch (error) {
        console.log(error);
      }
    },

    getMax(code) {
      return this.max_weight[code];
    },

    getMaxMarks(code) {
      const max = this.max_weight[code];
      const limit = 20;
      const skip = Math.ceil(max / limit);

      const marks = {};

      for (let index = 1;index <= max;index++) {
        if (limit > max) {
          if (index + (skip - 1) < max) marks[index] = `${index}`;
        } else if (index + (skip - 1) < max && index % skip === 0) marks[index] = `${index}`;
      }

      return marks;
    },

    createSelectZones() {
      const zones = [1, 2, 3, 4, 5, 6, 7, 8];
      return zones.map((zone) => ({
        value: zone,
        label: `Zona ${zone}`,
      }));
    },

    handleAdd() {
      this.enable_recipient.push(false);
      this.enable_recipient_states.push(false);

      this.backup.push({
        recipient: {
          filter_type: 'include',
          countries: [],
        },
      });

      this.backup_states.push({
        recipient: {
          filter_type: 'include',
          states: [],
        },
      });

      const type = this.distribution_type_selected;
      const rule = Rules.createEmpty(type);
      this.rules.push(rule);
    },

    removeItem(index, element) {
      this.$delete(element, index);
    },

    async handleSave() {
      const options = {
        message: 'Se guardaron los cambios con exito.',
        type: 'success',
        duration: 4000,
      };

      try {
        if (this.id) {
          await http.put(`/rules/${this.id}`, {
            carrier: this.data.carrier,
            rules: this.generateRules(this.rules),
            type: this.ruleType,
          });
        }

        this.update();
        this.handleClose();
      } catch (error) {
        const {
          data: {
            message,
          },
          status,
        } = error.response || {};
        options.duration = 0;
        options.showClose = true;
        options.message = message || status;
        options.type = 'error';
      } finally {
        this.$message(options);
      }
    },

    generateRules(sourceRules) {
      const rules = sourceRules.length ? sourceRules[0] : {};
      const emptyCountriesRecipient = !rules?.allowed_countries?.recipient?.countries?.length;
      const emptyCountriesShipper = !rules?.allowed_countries?.shipper?.countries?.length;
      const emptyCountries = emptyCountriesRecipient && emptyCountriesShipper;
      const emptyStatesRecipient = !rules?.allowed_states?.recipient?.states?.length;
      const emptyStatesShipper = !rules?.allowed_states?.shipper?.states?.length;
      const emptyStates = emptyStatesRecipient && emptyStatesShipper;

      if (emptyCountries) {
        delete rules.allowed_countries;
      }

      if (emptyStates) {
        delete rules.allowed_states;
      }
      return rules;
    },

    handleClose() {
      this.$delete(this.backup, 'recipient');
      this.$delete(this.backup_states, 'recipient');
      this.$emit('close');
    },

    update() {
      this.$emit('update');
    },
  },
};
</script>

<style>
  .el-slider__marks-text {
    font-size: 12px;
    color: #909399;
  }
  .el-card {
    margin-top: 15px;
  }
  .el-header, .el-footer {
   /* background-color: #B3C0D1;*/
    color: #333;
    text-align: center;
    line-height: 60px;
  }

  .el-aside {
   /* background-color: #D3DCE6;*/
    color: #333;
    text-align: center;
  }

  .el-main {
   /* background-color: #E9EEF3;*/
    color: #333;
    text-align: center;
  }

  body > .el-container {
    margin-bottom: 40px;
  }

  .el-container {
    -webkit-box-shadow: 0 0 2rem 0 rgba(136,152,170,.15);
    box-shadow: 0 0 2rem 0 rgba(136,152,170,.15);
    border-radius: 4px;
  }

  .el-select{
    width: 240px;
  }

  .range{
    color: #5e72e4;
    font-size: 12px;
  }
  .el-slider {
    margin-bottom: 30px;
  }

  .el-slider__runway{
    margin: 9px 0;
  }

  pre {
    margin: 0px;
  }

  .el-input{
    margin-bottom: 7px;
  }

  .pt-10{
    margin-top: 12px;
  }

 .filter-group {
  background-color: #4d527312;
  margin: 5px;
  padding: 5px 0px 10px 0px;
}
</style>
